import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { StoreService }  from '../../shared/store/store.service';
import { DeviceService } from '../../shared/device/device.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';

declare const _;

@Component({
  selector: 'device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.css']
})
export class DeviceDetailComponent implements OnInit {

    @Input() deviceIP = '';

    device = {};

    isDevicesDataLoading = true;
    isDevicesDataError = false;

    constructor(private router: Router, private deviceService: DeviceService) {

    }

    ngOnInit() {
        this.getDeviceDetail(this.deviceIP);
    }

    getDeviceDetail(deviceIP) {

        const self = this;

        const params = {ip: deviceIP};

        self.deviceService.getDevices(params).subscribe(function(devices) {

            var device = devices[0];
            self.device = device;
            console.log(device);
            device.last_seen = device.last_seen.replace(" ","Z");
            device.last_seen = new Date(device.last_seen);
            device.last_seen = device.last_seen.toLocaleDateString('en-US')+" "+device.last_seen.toLocaleTimeString('en-US', { hour12: false });

            self.isDevicesDataLoading = false;
            self.isDevicesDataError = false;

        }, function(err) {
            console.log('Error in getting device details. Called from device-detail.component.ts');
            console.log(err);
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/device-detail/device-detail.component.ts